import BaseTasksEvAHTMLPreviewStrategy from './BaseTasksEvAHTMLPreviewStrategy'

export default function AllTasksEvAHTMLPreviewStrategy() {}

AllTasksEvAHTMLPreviewStrategy.prototype = new BaseTasksEvAHTMLPreviewStrategy();

AllTasksEvAHTMLPreviewStrategy.prototype.init = function ( timeFormat ) {
    BaseTasksEvAHTMLPreviewStrategy.prototype.init.call( this, timeFormat );
    return this;
};

AllTasksEvAHTMLPreviewStrategy.prototype.getTableClass = function () {
    return "withThirdLvl";
};

AllTasksEvAHTMLPreviewStrategy.prototype.getColumnsNumber = function () {
    return 5;
};

AllTasksEvAHTMLPreviewStrategy.prototype.addFirstHeaderRowCells = function ( row ) {
    this.addCell( row, this.message( "report.budgeted_vs_actual.spent_time.total" ), "totalSpentTime", 1, 3 );
    this.addCell( row, this.message( "report.budgeted_vs_actual.spent_time.nonbudgeted" ), "timeForNotEst", 1, 3 );
    this.addCell( row, this.message( "report.budgeted_vs_actual.estimated_time" ), "estimatedGrTime", 4, 1 );
};

AllTasksEvAHTMLPreviewStrategy.prototype.addSecondHeaderRowCells = function ( row ) {
    this.addCell( row, this.message( "report.budgeted_vs_actual.spent_time" ), "subSpentTime", 1, 2 );
    this.addCell( row, this.message( "report.budgeted_vs_actual.estimated_time" ), "estTime", 1, 2);
    this.addCell( row, this.message( "report.budgeted_vs_actual.variance" ), "variance", 2, 1 );
};

AllTasksEvAHTMLPreviewStrategy.prototype.addThirdHeaderRowCells = function ( row ) {
    this.addCell( row, this.message( "report.budgeted_vs_actual.variance.mh" ), "estTimeVarianceMh" );
    this.addCell( row, this.message( "report.budgeted_vs_actual.variance.percent" ), "estTimeVariancePercent" );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/eva/AllTasksEvAHTMLPreviewStrategy.js